import store from '../../store';
import 'datejs';
import { INPUT_TYPES } from '../../constants/formElements';
import { getTranslation } from '../../utils/functions';

const validateTelNumber = ({ fieldCode: inputName }) => (number) => {
  const { telephoneNumberFormat } = store.getState().formConfig;
  const numberFormat = telephoneNumberFormat[inputName];

  if (!numberFormat || number.length === 0) return null;
  const { digitsAmount } = numberFormat;

  const currentDigitsNumber = number.replace(/\D/g, '')?.length;

  // Tel number length : 7-15 (include code)
  if (digitsAmount > 15) {
    if (currentDigitsNumber < 7) return getTranslation('WRONG_TELEPHONE_FORMAT');
    return null;
  }

  if (currentDigitsNumber !== digitsAmount) return getTranslation('WRONG_TELEPHONE_FORMAT');
  return null;
};

const validateDateOfBirth = ({
  required,
  properties: {
    errorMessageNotLaterThan,
    errorMessageRequired,
    notLaterThan,
    notEarlierThan,
    errorMessageNotEarlierThan,
  },
}) => (date) => {
  if (!required && !date) {
    return null;
  }
  if (!date) return getTranslation(errorMessageRequired);
  const formatedDate = new Date(date).toString('yyyy-MM-dd');

  if (notEarlierThan) {
    const isDateEarlier = Date.compare(Date.parse(notEarlierThan), Date.parse(formatedDate));
    if (isDateEarlier > 0) {
      return getTranslation(errorMessageNotEarlierThan);
    }
  }

  if (notLaterThan) {
    const isDateLater = Date.compare(Date.parse(formatedDate), Date.parse(notLaterThan));
    if (isDateLater > 0) {
      return getTranslation(errorMessageNotLaterThan);
    }
  }

  return null;
};

const CustomValidationFunc = {
  [INPUT_TYPES.PHONE_NUMBER]: validateTelNumber,
  [INPUT_TYPES.DATE_PICKER]: validateDateOfBirth,
};

export default CustomValidationFunc;
